import React from 'react';
export function ProblemSection() {
  const problems = [{
    emoji: '😰',
    title: 'Burnout Creativo',
    text: 'Arrivi in palestra esausto dopo aver passato ore a cercare esercizi su YouTube o Facebook che non sai come collegare tra loro.'
  }, {
    emoji: '🏐',
    title: 'Mancanza di Struttura',
    text: 'I tuoi allenamenti perdono ritmo. Improvvisi le progressioni e temi che i tuoi atleti non stiano migliorando in modo logico.'
  }, {
    emoji: '📱',
    title: 'Sovraccarico di Informazioni',
    text: 'Cerchi su Google e trovi esercizi contraddittori. Non sai quale struttura sia più efficace per una sessione di 90 minuti.'
  }, {
    emoji: '😩',
    title: 'Carico Mentale Massiccio',
    text: 'Gestire i genitori, gli atleti e la pianificazione ti impedisce di goderti la tua vera passione: stare in campo.'
  }];
  return <section className="bg-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <div className="bg-volley-teal/10 text-volley-teal-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-179">
            TI RICORDI DI QUESTO?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight mb-6 tracking-tight" data-id="element-180">
            Ami allenare, ma la{' '}
            <span className="italic text-volley-orange" data-id="element-181">preparazione</span> ti
            ruba tutto il tempo libero?
          </h2>
          <p className="text-lg text-volley-slate max-w-2xl mx-auto" data-id="element-182">
            Se sei un allenatore di pallavolo, probabilmente conosci bene una di
            queste situazioni:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-183">
          {problems.map((p, idx) => <div key={idx} className="bg-volley-paper rounded-3xl p-8 border border-volley-navy/5 hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-id="element-184">
              <div className="text-4xl mb-4" data-id="element-185">{p.emoji}</div>
              <h3 className="font-display text-xl font-semibold text-volley-navy mb-3" data-id="element-186">
                {p.title}
              </h3>
              <p className="text-volley-slate leading-relaxed" data-id="element-187">{p.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}